<template>
    <v-container fluid align-start ma-0 pa-1 class="container-height">
        <v-card outlined>
            <v-toolbar color="#6ECB63" @click="visible = !visible">
                <v-toolbar-title>{{ titleSalary }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon>
                    <v-icon>{{ visible ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>
            </v-toolbar>
            <v-slide-y-transition mode="in-out">
                <div v-if="visible" style="padding:5px;">
                    <v-row no-gutters fill-height>
                        <v-col cols="12">
                            <i-card-vertical headerTitle="" :useBtnList="[
                                'btnRetrieve'
                            ]" @btnRetrieve="btnRetrieve()">
                                <template v-slot:body>
                                    <v-layout column overflow-auto>
                                        <v-row dense>
                                            <v-col cols="12">
                                                <v-card class="d-flex align-center justify-center" min-height="40">
                                                    <v-col cols="6" ms="6" md="4">
                                                        <v-dialog ref="dialog" v-model="modal" :return-value.sync="date"
                                                            persistent width="290px">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-text-field 
                                                                    v-model="date" 
                                                                    label="Month"
                                                                    prepend-inner-icon="mdi-calendar" 
                                                                    readonly
                                                                    v-bind="attrs" 
                                                                    dense 
                                                                    outlined 
                                                                    hide-details="auto"
                                                                    v-on="on"
                                                                >
                                                                </v-text-field>
                                                            </template>
                                                            <v-date-picker 
                                                                v-model="date" 
                                                                type="month" 
                                                                scrollable>
                                                                <v-spacer></v-spacer>
                                                                <v-btn outlined width="70px" height="30px" text
                                                                    color="primary" @click="modal = false">
                                                                    Cancel
                                                                </v-btn>
                                                                <v-btn outlined width="70px" height="30px" text
                                                                    color="primary" @click="$refs.dialog.save(date)">
                                                                    OK
                                                                </v-btn>
                                                            </v-date-picker>
                                                        </v-dialog>
                                                    </v-col>
                                                    <v-col cols="6" ms="6" md="4">
                                                        <v-text-field label="Employee Code" v-model="empNo" dense outlined
                                                            prepend-inner-icon="mdi-account" :disabled="disabled"
                                                            hide-details="auto" @keydown.enter="btnRetrieve()" clearable />
                                                    </v-col>
                                                </v-card>
                                                    <v-card class="d-flex align-center justify-center" min-height="40">
                                                    <v-col cols="6" ms="6" md="4">
                                                        <v-select label="Department" v-model="selectedDeptCd"
                                                            :items="deptList" :disabled="disabled" item-text="deptNm"
                                                            item-value="deptCd" return-object outlined dense
                                                            @change="getGroupList(selectedDeptCd.deptCd)" />
                                                    </v-col>
                                                    <v-col cols="6" ms="6" md="4">
                                                        <v-select label="Group" v-model="selectedGroupCd" :items="groupList"
                                                            :disabled="disabled" item-text="grpNm" item-value="grpCd"
                                                            return-object outlined dense />
                                                    </v-col>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-layout>
                                </template>
                            </i-card-vertical>
                        </v-col>
                    </v-row>
                </div>
            </v-slide-y-transition>
        </v-card>
        <v-card class="pt-1">
            <v-row no-gutters>
                <v-col cols="12">
                    <v-data-table :headers="headers" :items="detailPICs" class="elevation-1">
                        <template v-slot:top>
                            <v-dialog v-model="dialog" 
                                      persistent
                                      transition="dialog-bottom-transition" 
                                      scrollable
                                      fullscreen
                                      >
                                <!-- <v-card flat shaped> -->
                                <v-card flat>    
                                    <v-card-title class="d-flex cyan darken-1" 
                                       :style="{'padding': '0', 'letter-spacing': '0.0125em'}">
                                        <v-card-title dense class="text-subtitle-1 ">
                                            {{ formTitle }}
                                        </v-card-title>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            icon
                                            @click="close"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                        <!-- <v-card-actions class="justify-end">
                                            <v-btn
                                              @click="close()">X
                                                
                                            </v-btn>
                                        </v-card-actions> -->
                                    </v-card-title>
                                    
                                    <DxScrollView  height="100%" width="100%">
                                        <div>
                                   
                                            <v-list style = "padding: 0px;" >
                                                <v-list-item v-for="(detail, i) in details" :key="i" >                                                         
                                                    <v-list-item-content>
                                                        {{ detail.alwNm }}
                                                    </v-list-item-content>

                                                    <v-list-item-action class="text-subtitle-1">{{ detail.plnAmt }} 
                                                    </v-list-item-action>
                                                </v-list-item>

                                            </v-list>
                                            <v-divider></v-divider>
                                            <v-list-item>
                                                <v-list-item-content>
                                                        Tổng:
                                                    </v-list-item-content>

                                                    <v-list-item-action class="text-subtitle-1">{{total}}
                                                    </v-list-item-action>
                                            </v-list-item>

                                        </div>  
                                    </DxScrollView>
                                </v-card>
                            </v-dialog>
                        </template>
                        <template v-slot:item.no="{ item }">
                            <v-chip color="primary" variant="outlined">
                                {{ item.no }}
                            </v-chip>
                            <v-chip class="ma-1" color="primary" variant="outlined">
                                {{ item.vnm }}
                            </v-chip>
                        </template>
                        <template v-slot:item.deptNm="{ item }">
                            <span color="#F3E99F" variant="outlined">
                                {{ item.deptNm }} - {{ item.grpNm }}
                            </span>
                        </template>
                        
                        <template v-slot:item.bsAmt="{ item }">
                            <span color="#E76161">
                                {{ item.bsAmt }}
                            </span>
                        </template>
                        <template v-slot:item.posNm="{ item }">
                            <span color="#E76161">
                                {{ item.posNm }}
                            </span>
                        </template>
                        <template v-slot:item.ann="{ item }">
                            <span color="#E76161">
                                {{ item.ann }}
                            </span>
                        </template>
                        <template v-slot:item.acntNo="{ item }">
                            <span color="#E76161">
                                {{ item.acntNo }}                                
                            </span>
                            <span color="#E76161">
                                {{ item.acntNm }}
                            </span>
                        </template>
                        <template v-slot:item.wage="{ item }">
                            <span color="#E76161">
                                {{ item.wage }}
                            </span>
                        </template>
                        <template v-slot:item.sal="{ item }">
                            <v-chip color="#FFA41B" variant="outlined">
                                {{ item.sal }}
                            </v-chip>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-btn class="ma-1" color="primary" small @click="Minus(item, 2)">
                                <v-icon small>
                                    mdi-minus
                                </v-icon>
                            </v-btn>
                            <v-btn color="primary" small @click="Plus(item, 1)">
                                <v-icon small>
                                    mdi-plus
                                </v-icon>
                            </v-btn>
                        </template> 
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card>
        <!-- 
        <v-btn height="45px" width="45px" class="topBtn" @click="scrollToTop()">
            <v-icon>mdi-chevron-up</v-icon>
        </v-btn> -->
        <v-btn v-show="scY > 50" fab small color="primary" app fixed right bottom @click="scrollToTop()">
            <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
        <VueToastify :notifyAction="notifyAction"></VueToastify>
    </v-container>
</template>
  
<script>
import { getDeptList, getGroupList, getv10a2000List, getv10a2000Detail, vni2unicode} from '@/api/view/mis/10/v10a2000.js';
import { getAuthor, getGroup } from '@/api/view/mis/10/v10aAuthor.js';
import baseview from '@/components/base/baseview.vue';
import ICardVertical from '@/components/common/iCardVertical.vue';
import DxDateBox from 'devextreme-vue/date-box';
import notify from 'devextreme/ui/notify' // message
import VueToastify from '@/components/toastify/VueToastify.vue'
import { DxScrollView } from "devextreme-vue/scroll-view";
import { getDateFormat, getPreMonth} from '@/utils/common.js'

function conVert(text) {
    let result = text;
    for (let i = 0; i < text.length; i++) {
        result = result.replace('-', '');
    }
    return result;
}
export default {
    mixins: [baseview],
    components: {
        ICardVertical,
        DxDateBox,
        VueToastify,
        DxScrollView     
    },
    data: () => ({
        dialog: false,

        headers: [
            { text: 'No', align: 'start', value: 'no', sortable: false, },           
            { text: 'Nhóm', align: 'center', value: 'deptNm', sortable: false },
            { text: 'Chức vụ', align: 'center', value: 'posNm', sortable: false },            
            { text: 'Phép năm còn lại', align: 'end', value: 'ann', sortable: false },           
            { text: 'Lương cơ bản', align: 'end', value: 'bsAmt', sortable: false },
            { text: 'Lương giờ', align: 'end', value: 'wage', sortable: false },
            { text: 'Lương thực lĩnh', align: 'end', value: 'sal', sortable: false },
            { text: 'Tài Khoản & Ngân hàng', align: 'end', value: 'acntNo', sortable: false },            
            { text: 'Thông tin chi tiết', align: 'end', value: 'actions', sortable: false },
        ],
        
        // date: new Date().toISOString().substr(0, 7),
        // yaer: new Date().getFullYear(),
        // month: new Date().getMonth() - 1,
        // date: this.yaer + this.month,
        menu: false,
        modal: false,
        selectedDeptCd: '',
        deptList: [],
        selectedGroupCd: '',
        groupList: [],
        empNo: '',
        detailPICs: [],
        details: [],
        scTimer: 0,
        scY: 0,
        formTitle: '',
        visible: true,
        useYn: '',
        disabled: false,
        total: 0,
        titleSalary: '',
        date:'',
    }),

    created() {
        this.get_Month(new Date() )
        this.getList()
        this.getGroupList(this.selectedGroupCd)
        window.addEventListener('scroll', this.handleScroll);
        this.author(this.$store.state.user.userId)        
        this.titleSalary = 'Lương tháng '+ (this.date).substr(-2) + '/' + (this.date).substr(0,4)
        
    },

    methods: {

         get_Month(date) {
          
            var year = date.getFullYear();
            var month = String(date.getMonth() + 1).padStart(2, '0'); //month = ( 0 + date.getMonth())

           // month = month >= 10 ? month : '0' + month;
            //console.log('####Month', month)    
            this.date = year.toString()+'-'+ month.toString()
            // console.log('####Month', this.date)          
           return this.date
        },

        handleScroll: function () {
            if (this.scTimer) return;
            this.scTimer = setTimeout(() => {
                this.scY = window.scrollY;
                clearTimeout(this.scTimer);
                this.scTimer = 0;
            }, 100);
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },

        notifyAction(notifyInfo, action) {
            this.$EventBus.$emit(`${this.$route.meta.menu_id}_notifyAction`, { notifyInfo: notifyInfo, action: action })
        },

        
        async getGroupList(deptCd) {
            let params = {
                deptCd: deptCd == ""? "%": deptCd,
            }
            //console.log('params', params)    
            await getGroupList(params).then(res => {
                this.groupList = res.list
                this.groupList.unshift({
                    grpCd: '%',
                    grpNm: 'All'
                })
                this.selectedGroupCd = this.groupList[0]
            })
        },

        getList() {
            getDeptList({}).then(res => {
                this.deptList = res.list
                this.deptList.unshift({
                    deptCd: '%',
                    deptNm: 'All'
                })
                this.selectedDeptCd = this.deptList[0]
            })
        },
        
        async author(empNo) {
            let params = {
                menuId: 'v10a2000',
                empNo: empNo,
                tabNo: '99',
                div: '1'
            }
            await getAuthor(params).then(res => {
                res.list.forEach(e => {
                    this.useYn = e.useYn
                });
            })

            await getGroup(params).then(res => {
                res.list.forEach(e => {
                    this.grpCd = e.grpCd
                });
            })

            // console.log(this.useYn)
            // console.log(this.grpCd)
            if (this.useYn != 'Y' || this.useYn== null) {
                this.disabled = true
                this.empNo = empNo
            }
        },


        btnRetrieve() {
            this.titleSalary = 'Lương tháng '+ (this.date).substr(-2) + '/' + (this.date).substr(0,4)
            this.getv10a2000List()
        },
        async getv10a2000List() {
            this.openLoading('searching')
            let params = {
                empNo: !this.empNo ? '' : this.empNo,
                deptCd: this.selectedDeptCd.deptCd,
                grpCd: this.selectedGroupCd.grpCd,
                lsMonth: conVert(this.date),
            }
            await getv10a2000List(params).then(res => {
                let list = []
                let cnt = 1;
                res.list.forEach(e => {

                    list.push(
                        {
                            id: cnt++, no: e.no, empNo: e.empNo, mobile: e.mobile, grpNm: e.grpNm, deptNm: e.rtId == '7' ? e.deptNm + ' - ' + e.grpNm : e.deptNm,
                            enm: vni2unicode(e.enm), vnm: vni2unicode(e.vnm), bsAmt: new Intl.NumberFormat("en-US").format(e.bsAmt), posNm: e.posNm, acntNo: e.acntNo,
                            ann: !e.ann ? 0 : e.ann, acntNm: e.acntNm, wage: new Intl.NumberFormat("en-US").format(e.wage),
                            sal: new Intl.NumberFormat("en-US").format(e.sal), 
                        }
                    )
                    // 
                })
                if (list.length < 1) {
                    this.vToastify(this.$t('No data'), 'warn')
                    return
                } else {
                    this.detailPICs = list
                    this.visible = false
                }
            }).finally(() => {
                this.endLoading()

            })
        },

        getv10a2000Detail(empNo, div) {
            let params = {
                empNo: empNo,
                lsMonth: conVert(this.date),
                div: div
            }
            getv10a2000Detail(params).then(res => {
                let list = []
                let cnt = 1;
                let tong = 0;
                res.list.forEach(e => {
                    list.push(
                        {
                            id: cnt++, empNo: e.empNo, enm: e.enm,  alwNm: vni2unicode(e.alwNm), 
                            deptNm: e.rtId == '7' ? e.deptNm + ' - ' + e.grpNm : e.deptNm,
                            plnAmt: new Intl.NumberFormat("en-US").format(e.plnAmt), 
                        }
                       
                    )
                    tong = tong + parseInt(e.plnAmt)
                    this.total = new Intl.NumberFormat("en-US").format(tong)
                    // 
                })
                this.details = list
            }).finally(() => {

            })
        },

        Plus(item, div) {
            // console.log('####PlusItem: ', item.enm)
            this.formTitle = item.enm +' - Tiền Cộng tháng ' + (this.date).substr(-2) + '/' + (this.date).substr(0,4)
            this.getv10a2000Detail(item.empNo, div)
            this.dialog = true
        },

        Minus(item, div) {
            this.formTitle = item.enm +' - Tiền Trừ tháng ' + (this.date).substr(-2) + '/' + (this.date).substr(0,4)
            this.getv10a2000Detail(item.empNo, div)
            this.dialog = true
        },

        close() {
            this.details = []
            this.dialog = false
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        }
    },
}
</script>
<style >
* {
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
}

/* tao duong line o table vuejs*/
.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr:last-child>th {
    border-right: 1px solid white;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr>td:not(.v-data-table__mobile-row),
.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>th:not(.v-data-table__mobile-row) {
    border-right: 1px solid rgb(209, 208, 208);

}

/*tang khoang cach cua 2 gia tri tren mobile*/
.v-data-table>.v-data-table__wrapper .v-data-table__mobile-row {
    height: initial;
    min-height: 0px;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
    padding: 4px;
}

/*tang khoang cach cua 2 gia tri tren mobile*/
.v-data-table>.v-data-table__wrapper .v-data-table__mobile-table-row {
    border-radius: 10px;
    padding: 10px;
    margin: 5px;
    border: 1px solid #ededed;
    display: block;
    background-color: rgb(233, 242, 252);
}

.v-data-table-header {
    background-color: rgb(233, 242, 252);
    font-weight: bold;
    text-align: center;
    justify-content: center;
    padding: 0%;
}

/* .v-dialog > .v-card > .v-card__title {
    font-size: 1rem;
    font-weight: 300;
    letter-spacing: 0.0125em;
    padding: 5px;
} */

</style>